import { Data, DateGrouping } from '../models';
import { api } from '@/shared/services/baseApiClient';
import urljoin from 'url-join';
import { config } from '@/config/config';
import { QueryStringBuilder } from '@/shared/services/queryStringBuilder';

class NlpReportApiService {
  private version = 'v1';

  public get(modelId: string, request: ReportRequest): Promise<NlpReportsResponse> {
    const query = new QueryStringBuilder()
      .add('startDate', request.startDate.toISOString())
      .add('endDate', request.endDate.toISOString())
      .add('grouping', request.grouping)
      .build();

    return api.send('GET', urljoin(config().nlpHost, this.version, modelId, `reports`) + query);
  }
}

export interface ReportRequest {
  startDate: Date;
  endDate: Date;
  grouping: DateGrouping;
}

export interface NlpReportsResponse {
  mostPopularTotalsReport: Data;
  mostPopularTrendReport: Data;
  highestConfidenceTotalsReport: Data;
  lowestConfidenceTotalsReport: Data;
  lowestConfidenceTrendReport: Data;
  highestConfidenceTrendReport: Data;

  confidenceAverage: number;
}

export const nlpReportApi = new NlpReportApiService();
